import type { FkspRequestType, FkspRequestStatus } from '../types'

/** Počet řádků FKSP na jedné stránce seznamu. */
export const FKSP_PAGE_SIZE = 300
/** Načtení seznamu pro role s filtry (personalista, ZOČMOS, ředitel, ekonom). */
export const FKSP_LIST_FETCH_LIMIT = 10000
/** Žadatel / kabinet — max. dle API pro běžné role. */
export const FKSP_REQUESTER_FETCH_LIMIT = 500

export const FKSP_PRIPOJISTENI_MAX_KC = 400

export const FKSP_BENEFIT_OPTIONS = [
  'Příspěvek na rekreaci a cestování (Odst. 2.02, písm. a) Zásad)',
  'Příspěvek na relaxaci, rehabilitaci a odpočinek (Odst. 2.02, písm. b) Zásad)',
  'Příspěvek na kulturní a sportovní aktivity (Odst. 2.02, písm. c) Zásad)',
  'Příspěvek na sportovní a volnočasové vybavení (Odst. 2.02, písm. d) Zásad)',
  'Příspěvek na podpora čtenářství (Odst. 2.02, písm. e) Zásad)',
  'Příspěvek na zdravotní péči (Odst. 2.02, písm. f) Zásad)',
  'Příspěvek na vzdělávací aktivity (Odst. 2.02, písm. g) Zásad)',
  'Příspěvek na nepeněžitý dar při životním či pracovním jubileu (Odst. 2.05, Zásad)',
] as const

export const FKSP_PRIPOJISTENI_OPTIONS = [
  'Příspěvek na penzijní připojištění se státním příspěvkem podle zákona (Odst. 2.04, písm. a) Zásad)',
  'Příspěvek na doplňkové penzijní spoření podle zákona (Odst. 2.04, písm. b) Zásad)',
  'Příspěvek na soukromé životní pojištění (Odst. 2.04, písm. c) Zásad)',
] as const

export type FkspTypeFilter = 'all' | FkspRequestType
export type FkspProcessedFilter = 'all' | 'processed' | 'unprocessed'
export type FkspStatusFilter = 'all' | FkspRequestStatus
export type FkspFilledFilter = 'all' | 'filled' | 'empty'
export type FkspEkonomSortField = 'created_at' | 'requester_name' | 'doplaceno' | 'datum'
export type FkspSortField = FkspEkonomSortField
